import { lazyInject } from '../../services/inversify';
import { ContextService } from '../../services/context_service';
import { IDs } from '../../helpers/IDs';
import * as React from 'react';
import * as classNames from 'classnames';
import style from './SubHeader.less';
import { ApiService } from '../../services/api_service';
// import { SideNavigation } from '../informationen_hilfe/SideNavigation';
import { DataService } from '../../services/data_service';
import { TriggerService } from '../../core/trigger/trigger_service';
import Select from 'react-select';
import { WHelpIcon } from '../../core/elements/WHelpIcon';
import { i18n } from '../../i18n/i18n';
import { WFormFieldSelectOption } from '../../core/forms/fields/WFormFieldSelect';
import { WArchivIcon } from '../../core/elements/WArchivIcon';
import { resizeImageB64ToUrl } from '../../core/forms/helpers/resizeImage';
import { getRoutingFromLocationHash } from '../../main/functions/locationHash';

interface SubHeaderProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    reloadData: () => void;
    standortSelected: any;
    routing: any;
    onClickNaviBackBtn?: () => void;
    onClickNaviNextBtn?: () => void;
    isGefuehrterModus: boolean;
    hideNavi?: boolean;
}

interface SubHeaderState {
    dummy?: number;
    routingIndex: number;
}

export class SubHeader extends React.Component<SubHeaderProps, SubHeaderState> {

    constructor(props: any) {
        super(props);
        this.resizeUnternehmenLogo = this.resizeUnternehmenLogo.bind(this);
        this.state = {
            routingIndex: 0
        };
        this.resizeUnternehmenLogo = this.resizeUnternehmenLogo.bind(this);
    }

    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;
    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;

    private varianten: any[] = [
        { key: 'classic', name: 'E-Tool classic' },
        { key: 'cfm', name: 'CO₂-Fußabdruck' },
        { key: 'steuer', name: 'Strom- und Energiesteuer' },
        { key: 'nachhaltigkeit', name: 'Nachhaltigkeit' },
        { key: 'vsme', name: 'VSME-Modul' }
    ];

    componentDidMount(): void {
        
    }

    componentDidUpdate(prevProps: any): void {
        const locationRouting: any = getRoutingFromLocationHash(window.location.hash, this.contextService) || {};
        const routingIndex = locationRouting['path'] && locationRouting['path']['selectedMenu'] ? locationRouting['path']['selectedMenu'] : 0;
        if (routingIndex !== this.state.routingIndex) {
            this.setState({routingIndex}, () => {
                console.log('selected routing', routingIndex);
            });
        }
    }

    render(): JSX.Element {
        const data: any = this.props.data || {};
        const konfiguration: any = (data[IDs.ENT_KONFIGURATION] || [])[0] || {};
        const modul: string = data.MODUL_SELECTED || null;

        return (
            <div className={style.header}>
                <div className={style.left}>{this.renderLeft()}</div>
                <div className={style.middle}>{this.renderMiddle()}</div>
                <div className={style.right}>{this.renderRight()}</div>
            </div>
        );
    }

    renderLeft(): JSX.Element {
        const konfiguration: any = ((this.props.data || {})[IDs.ENT_KONFIGURATION] || [])[0] || {};
        const showVsme: boolean = konfiguration.vsme_orig === 1;
        // const icon_blatt = require('../../img/blatt.png');

        let themeNode = 'dateneingabe';
        let buttonTheme = 'theme_info_blue';
        switch (this.state.routingIndex) {
            case 1:
                themeNode = 'datenauswertung';
                buttonTheme = 'theme_info_green';
                break;
            // case 3:
            case 2:
                themeNode = 'zusatztools';
                buttonTheme = 'theme_info_orange';
                break;
            // case 4:
            case 3:
                themeNode = 'informationen_hilfe';
                buttonTheme = 'theme_info_grey';
                break;
        }

        if (this.props.hideNavi) {
            themeNode = 'datenauswertung';
            buttonTheme = 'theme_info_green';
        }

        const optionsForSelect = this.varianten
            .filter((opt: any, idx: number) => (!showVsme && opt.key === 'vsme') /* || (!showCfm && opt.key === 'cfm')*/ ? false : true)
            .map((opt: any, idx: number) => {
                const option: WFormFieldSelectOption = {
                    index: idx,
                    value: opt.key,
                    label: <div className={style.modulOption}>
                        {/* <img src={icon_blatt} style={{ marginRight: 10, height: 15 }} alt='' /> */}
                        {i18n(opt.name, 'sys')}
                    </div>
                };
                return option;
            });
        const modeSel = this.props.data.MODUL_SELECTED || null;
        const optionSelected = optionsForSelect.find((opt) => opt.value === modeSel);
        const defaultStyle = { minHeight: 1, height: 35, padding: '0 5px' };
        const CustomDropdownIndicator = (props: any) => {
            return (
                <div {...props.innerProps} style={{ padding: '0 1px', fontSize: 'larger', color: `var(--color-subheader-option-${themeNode})`}}>
                🡫
                </div>
            );
        };

        return <>
            <div style={{ fontSize: 16, width: 172 }}>
                <Select
                    placeholder='Auswahl Modul'
                    options={optionsForSelect}
                    value={optionSelected}
                    onChange={(event: any) => {
                        const mode = event.value;
                        if (mode !== modeSel) {
                            if (typeof this.props.data.MODUL_ON_SELECT === 'function') {
                                this.props.data.MODUL_ON_SELECT(mode);
                            }

                        }
                    }}
                    components={{
                        DropdownIndicator: CustomDropdownIndicator
                    }}
                    styles={{
                        option: (provided, state) => ({
                            ...provided,
                            ...defaultStyle,
                            padding: 5,
                            height: '100%',
                            
                            color: state.isSelected 
                                ? 'white' 
                                : `var(--color-subheader-option-${themeNode})`,
                                
                            backgroundColor: state.isSelected 
                                ? `var(--color-subheader-option-${themeNode})` 
                                : state.isFocused 
                                    ? 'rgba(0,0,0,0.05)' // Ein leichter Fokus-Effekt
                                    : 'transparent',

                            '&:active': {
                                backgroundColor: `var(--color-subheader-option-${themeNode})`
                            }
                        }),
                        singleValue: (provided) => ({
                            ...provided,
                            color: `var(--color-subheader-option-${themeNode})`
                        }),
                        control: (provided: any, state: any) => {
                                return {
                                    ...provided,
                                    ...defaultStyle,
                                    borderColor: `var(--color-subheader-option-${themeNode})`,
                                    boxShadow: state.isFocused 
                                        ? `0 0 0 1px var(--color-subheader-option-${themeNode})` 
                                        : null,
                                    '&:hover': {
                                        borderColor: `var(--color-subheader-option-${themeNode})`
                                    }
                                };
                            },
                        valueContainer: (provided: any, state: any) => {
                            return {
                                ...provided,
                                ...defaultStyle
                            };
                        },
                        indicatorsContainer: (provided: any, state: any) => {
                            return {
                                ...provided,
                                ...defaultStyle,
                                width: 30
                            };
                        },
                        dropdownIndicator: (provided: any, state: any) => {
                            return {
                                ...provided,
                                color: `var(--color-subheader-option-${themeNode})`
                            };
                        }
                    }}
                />
            </div>
            <div
                style={{
                    paddingTop: 8, boxSizing: 'border-box',
                    backgroundColor: '#fff', height: 35, width: 35, marginLeft: 10,
                    textAlign: 'center', borderRadius: '5px',
                    border: `solid 1px var(--color-subheader-option-${themeNode}`
                }}
                className={`cont-${themeNode}`}
            >
                <WHelpIcon
                    data={this.props.data}
                    styleProps={{
                        width: 18, height: 18, backgroundColor: 'white', margin: '2px auto auto auto',
                        // filter: !this.props.hideNavi && themeNode === 'zusatztools' ? 'brightness(0) saturate(100) invert(77%) sepia(99%) saturate(3602%) hue-rotate(317deg) brightness(93%) contrast(96%)' : ''
                    }}
                    label='Hinweise'
                    helpKey='assistent_auswahl_modul'
                    type={buttonTheme}
                    useTheme={!this.props.hideNavi}
                    editBar={true}
                    containerId={themeNode}
                />
            </div>
        </>;
    }

    renderMiddle(): JSX.Element {
        const { hideNavi, onClickNaviBackBtn, onClickNaviNextBtn } = this.props;
        if (hideNavi) {
            return null;
        }

        let themeNode = 'dateneingabe';
        switch (this.state.routingIndex) {
            case 1:
                themeNode = 'datenauswertung';
                break;
            // case 3:
            case 2:
                themeNode = 'zusatztools';
                break;
            // case 4:
            case 3:
                themeNode = 'informationen_hilfe';
                break;
        }

        return <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                {typeof onClickNaviBackBtn === 'function' &&
                    <div
                        className={classNames(style.naviBtn, style.naviBackBtn, `cont-${themeNode}`)}
                        onClick={onClickNaviBackBtn}
                    />
                }
                {typeof onClickNaviNextBtn === 'function' &&
                    <div
                        className={classNames(style.naviBtn, style.naviNextBtn, `cont-${themeNode}`)}
                        onClick={onClickNaviNextBtn}
                    />
                }
            </div>
            {false && this.props.isGefuehrterModus && <>
                <label
                    className={style.toggleCheckboxWrapper}
                    style={{ marginLeft: 15, marginRight: 10 }}
                >
                    {/* Slider später fertigstellen - wenn On, sollen die Kurzinfos immer als "Bubbles" rechts zu sehen sein*/}
                    <input className={style.toggleInput} type='checkbox' checked={false} />
                    <span className={style.toggleSliderOff}></span>
                </label>
                <div className={style.toggleCheckboxText}>Tipps bei der Eingabe anzeigen</div>
            </>}
        </div>;
    }

    renderRight(): JSX.Element {
        let unternehmen: any = {};
        const data = this.props.data;
        if (data && Array.isArray(data[IDs.ENT_UNTERNEHMENSDATEN]) && data[IDs.ENT_UNTERNEHMENSDATEN].length > 0) {
            unternehmen = data[IDs.ENT_UNTERNEHMENSDATEN][0];
        }
        if (unternehmen && unternehmen.datei_logo > 0) {
            return <div style={{
                marginTop: 0, marginRight: 0, display: 'flex', textAlign: 'right', boxSizing: 'border-box',
                flexDirection: 'column', justifyContent: 'space-around', flex: 1, paddingRight: '20px'
            }}>
                <WArchivIcon
                    archivId={unternehmen.datei_logo}
                    previewMaxHeight={70}
                    previewMaxWidth={240}
                    hideFilename={true}
                    URLContextKey={'UNTERNEHMEN_LOGO_URL'}
                    onGetFileContent={this.resizeUnternehmenLogo}
                />
            </div>;
        }
        return <div></div>;
    }

    resizeUnternehmenLogo(blob: any, url: string, base64: string): void {
        const jobs = [
            // { contextKey: 'UNTERNEHMEN_LOGO_RESIZE_100_URL', maxWidth: 100, maxHeight: 100 },
            { contextKey: 'UNTERNEHMEN_LOGO_RESIZE_200_URL', maxWidth: 200, maxHeight: 200 }
        ];
        const mimeType: string = blob && blob.type ? blob.type : 'image/jpeg';
        const that = this;
        jobs.forEach((j: any) =>
            resizeImageB64ToUrl(base64, mimeType, (url: string) => {
                that.contextService.set(j.contextKey, url);
            }, j.maxWidth, j.maxHeight, blob)
        );
    }

}
